import { render, staticRenderFns } from "./outsourcing.vue?vue&type=template&id=691c479c&"
import script from "./outsourcing.vue?vue&type=script&lang=js&"
export * from "./outsourcing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports